import { CMS_DETAILS } from './actionTypes';

const initialState = {
  cmsDetailsData: [],
  loading: {
    cmsDetailsData: false,
  },
  error: {
    cmsDetailsData: null,
  },
};

const CmsDetailsReducer = (state = initialState, action) => {
  const { type, payload, error } = action;

  switch (type) {
    case CMS_DETAILS.CMS_DETAILS_REQUEST:
      return {
        ...state,
        loading: { ...state.loading, cmsDetailsData: true },
        error: { ...state.error, cmsDetailsData: null },
      };
    case CMS_DETAILS.CMS_DETAILS_SUCCESS:
      return {
        ...state,
        cmsDetailsData: payload && payload.data,
        loading: { ...state.loading, cmsDetailsData: false },
      };
    case CMS_DETAILS.CMS_DETAILS_FAILURE:
      return {
        ...state,
        loading: { ...state.loading, cmsDetailsData: false },
        error: { ...state.error, cmsDetailsData: error },
      };
    default:
      return state;
  }
};

export default CmsDetailsReducer;
